import { digObject } from '@domain-group/javascript-utils'
import useSelector from '@hooks/useSelector'

import { ActivityModel, ProviderPriceListItemOptionModel, ProviderPriceListItemOptionValueModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

const getItem = (
  entityType: string,
  entityId: number,
  items: EntitiesState['providerPriceListItems'],
  option?: ProviderPriceListItemOptionModel,
) => {
  if (entityType === 'ProviderPriceListItem') return items[entityId]
  if (option?.provider_price_list_item_id) return items[option?.provider_price_list_item_id]

  return undefined
}

const getOption = (
  entityType: string,
  entityId: number,
  options: EntitiesState['providerPriceListItemOptions'],
  value?: ProviderPriceListItemOptionValueModel,
) => {
  if (entityType === 'ProviderPriceListItemOption') return options[entityId]
  if (value?.provider_price_list_item_option_id){
    return options[value?.provider_price_list_item_option_id]
  }

  return undefined
}

const getValue = (
  entityType: string,
  entityId: number,
  values: EntitiesState['providerPriceListItemOptionValues'],
) => {
  if (entityType === 'ProviderPriceListItemOptionValue') return values[entityId]
  return undefined
}

const usePriceListActivity = (activity: ActivityModel) => {
  const {
    providerPriceListItems, providerPriceListItemOptions, providerPriceListItemOptionValues, serviceProducts,
  } = useSelector(reduxState => reduxState.entities)

  const { action, parameters } = activity
  const { changes, entity_id, entity_type } = parameters || {}

  // @ts-expect-error TS2345
  const value = getValue(entity_type, entity_id, providerPriceListItemOptionValues)
  // @ts-expect-error TS2345
  const option = getOption(entity_type, entity_id, providerPriceListItemOptions, value)
  // @ts-expect-error TS2345
  const item = getItem(entity_type, entity_id, providerPriceListItems, option)
  const product = item?.service_product_id ? serviceProducts[item?.service_product_id] : undefined

  const hideChanges = action === 'merge_price_lists'
  || action === 'bulk_reassign_agencies'
  || action === 'adjust_prices_by_percentage'

  // @ts-expect-error TS2345
  const originalPriceListId = digObject(changes, 'bulk_reassign_agencies.original_provider_price_list_id')
  // @ts-expect-error TS2345
  const nextPriceListId = digObject(changes, 'bulk_reassign_agencies.next_provider_price_list_id')
  // @ts-expect-error TS2345
  const reassignedAgencyIds = digObject(changes, 'bulk_reassign_agencies.agency_ids')
  // @ts-expect-error TS2345
  const reassignedAgencyProviderIds = digObject(changes, 'bulk_reassign_agencies.agency_provider_ids')

  // @ts-expect-error TS2345
  const changeDirection = digObject(changes, 'adjust_prices_by_percentage.direction')
  // @ts-expect-error TS2345
  const changePercentage = digObject(changes, 'adjust_prices_by_percentage.percentage')

  return {
    activity,
    agenciesReassignedFromPriceListId: originalPriceListId,
    changeDirection,
    // @ts-expect-error TS2769
    changeKeys: Object.keys(changes),
    changePercentage,
    hideChanges,
    item,
    // @ts-expect-error TS2345
    mergedIds: digObject(parameters, 'merged_price_lists.price_list_ids'),
    nextPriceListId,
    option,
    product,
    reassignedAgencyIds,
    reassignedAgencyProviderIds,
    value,
  }
}

export default usePriceListActivity
